import { useState, useRef } from 'react';
import colombiaMapService from '../../../services/ColombiaMapService';
import { SERVICE_DATA } from '../../../shared/population-colors';
import { SearchResult } from '../types';

export const useSearchInput = () => {
  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState<SearchResult[]>([]);
  const [noSearchResult, setNoSearchResult] = useState(false);
  const [isSearchResultOpen, setIsSearchResultOpen] = useState(false);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const hideSearchResults = () => {
    setTimeout(() => setIsSearchResultOpen(false), 300);
  };

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const queryRaw = e.target.value;
    const query = queryRaw.trim();
    setSearchInput(queryRaw);
    setNoSearchResult(false);
    setIsSearchResultOpen(query.length >= 3);

    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (query.length < 3) {
      setSearchResult([]);
      return;
    }

    debounceRef.current = setTimeout(() => {
      const results = colombiaMapService.onSearch({ target: { value: query } });
      setSearchResult(results || []);
      setNoSearchResult(query.length >= 3 && (!results || results.length === 0));
    }, 300);
  };

  const selectSearchResult = (ev: React.MouseEvent, res: SearchResult, onServiceSelect: (serviceKey: string) => void) => {
    ev.preventDefault();
    setSearchResult([]);
    setNoSearchResult(false);

    if (res.type === "Feature") {
      return res;
    } else {
      const serviceKey = Object.keys(SERVICE_DATA).find(key =>
        SERVICE_DATA[key].label === res.name || SERVICE_DATA[key].name === res.name.toLowerCase()
      );
      if (serviceKey) {
        onServiceSelect(serviceKey);
      }
      clearInput();
      return null;
    }
  };

  const clearInput = () => setSearchInput("");

  return {
    searchInput,
    searchResult,
    noSearchResult,
    isSearchResultOpen,
    hideSearchResults,
    onSearch,
    selectSearchResult,
    clearInput,
  };
};
